import { Module } from "vuex";
import { ApiStatus, ApiStoreStateInterface } from "@/store-services/api.types";

export const UPDATE_STATUS = "UPDATE_STATUS"

export const apiStore: Module<ApiStoreStateInterface, any> = {
  namespaced: true,
  state: {
    status: "connecting"
  },
  mutations: {
    [UPDATE_STATUS](state, payload: ApiStatus) {
      state.status = payload
    }
  },
  getters: {
    getStatus: (state) => () => {
      return state.status
    }
  }
}